import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const box = {
	backgroundColor: "#f4e4df",
	border: "2px solid #de5624",
	borderRadius: "16px",
	padding: "8px",
};
const h3 = {
	fontFamily: "'Poppins', sans-serif",
	fontSize: 14,
	fontWeight: 700,
	textTransform: "uppercase",
	marginBottom: 0,
	color: "#de5624",
};
const p = {
	fontFamily: "'Poppins', sans-serif",
	fontSize: 13,
	color: "#444",
	margin: 0,
};
const ul = {
	paddingLeft: 0,
	margin: 0,
	marginLeft: -2,
	fontSize: 13,
};

// Template127: Aeropuertos (Airports.jsx guia-londres). Todo desde backend.
// page.texts[0]=header, [1]=intro, [2-9]=títulos y listas Heathrow/Gatwick/Stansted/Luton, [10]=consejo título, [11]=consejo HTML
const Template127 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const logoImage =
		page.canvasImages?.find((img) => img.id === "logo")?.imageUrl ||
		"/images/logo.png";
	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found) return found.src ?? found.url;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const introText = page?.texts?.[1]?.content;
	const blocks = [
		[page?.texts?.[2]?.content, page?.texts?.[3]?.content],
		[page?.texts?.[4]?.content, page?.texts?.[5]?.content],
		[page?.texts?.[6]?.content, page?.texts?.[7]?.content],
		[page?.texts?.[8]?.content, page?.texts?.[9]?.content],
	];
	const consejoTitle = page?.texts?.[10]?.content;
	const consejoHtml = page?.texts?.[11]?.content;

	const airportSticker =
		getImageSrc("airport-sticker") || getCanvasImageUrl("airport-sticker");
	const taxiSticker = getImageSrc("taxi") || getCanvasImageUrl("taxi-sticker");
	const actualHeaderColor = headerBackgroundColor || "#de5624";

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: isSmallScreen ? 66 : 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: 13, color: "#444" }}>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}

			<Box
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: "16px",
					position: "relative",
				}}
			>
				{blocks.map(
					([title, listHtml], i) =>
						title && (
							<Box key={i} data-block-id={`text-${i + 2}`} sx={box}>
								<Box component="h3" sx={{ ...h3, marginTop: 0 }}>
									{title}
								</Box>
								{listHtml && (
									<Box
										component="div"
										sx={ul}
										dangerouslySetInnerHTML={{ __html: listHtml }}
									/>
								)}
							</Box>
						),
				)}

				{airportSticker && (
					<img
						src={airportSticker}
						alt=""
						style={{
							width: isSmallScreen ? 90 : 100,
							position: "absolute",
							top: isSmallScreen ? 120 : 40,
							right: -10,
						}}
					/>
				)}
				{taxiSticker && (
					<img
						src={taxiSticker}
						alt=""
						style={{
							width: 100,
							position: "absolute",
							bottom: isSmallScreen ? -80 : 70,
							right: -10,
						}}
					/>
				)}

				{consejoHtml && (
					<Box
						data-block-id="text-6"
						sx={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "12px",
							padding: "12px 14px",
							fontSize: 12,
							marginTop: "0px",
							marginBottom: "0px",
						}}
					>
						{consejoTitle && (
							<Box
								component="h4"
								sx={{
									marginTop: 0,
									marginBottom: "8px",
									fontSize: 13,
									color: "#f5c400",
									fontWeight: 700,
									textTransform: "uppercase",
								}}
							>
								{consejoTitle}
							</Box>
						)}
						<Box
							component="div"
							dangerouslySetInnerHTML={{ __html: consejoHtml }}
						/>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template127.thumbnail = "/images/template-1.png";

export default Template127;
